import { Action } from '@ngrx/store';

export const GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER = '[CRM] Get Service Group Sub Categories From Server';
export class GetServiceGroupSubCategoriesFromServer implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER;
  readonly triggerStorageSync = false;
  // constructor(public payload: ServiceGroupSubCategory) {}
  constructor(public payload: any) {}
}

export const GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER_SUCCESS =
  '[CRM] Get Service Group Sub Categories From Server Success';
export class GetServiceGroupSubCategoriesFromServerSuccess implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  // constructor(public payload: { serviceGroupSubCategories: ServiceGroupSubCategory[] }) { }
  constructor(public payload: { serviceGroupSubCategories: any[] }) {}
}

export const GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER_FAILURE =
  '[CRM] Get Service Group Sub Categories From Server Failure';
export class GetServiceGroupSubCategoriesFromServerFailure implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type ServiceGroupSubCategoriesAction =
  | GetServiceGroupSubCategoriesFromServer
  | GetServiceGroupSubCategoriesFromServerSuccess
  | GetServiceGroupSubCategoriesFromServerFailure;
